// import { ROUTER_NAMES } from './routerNamesConfig'

export const NAVIGATION_ROUTE_TYPES = {
	base: {
		key: 'base',
	},
	userPages: {
		key: 'userPages',
	},
	referenceMaterials: {
		key: 'referenceMaterials',
	},
	profileSettings: {
		key: 'profileSettings',
	},
	companySettings: {
		key: 'companySettings',
	},
	companyPersonalSettings: {
		key: 'companyPersonalSettings',
	},
	companySettingsChild: {
		key: 'companySettingsChild',
	},
	group: {
		key: 'group',
	},
	module: {
		key: 'module',
	},
	view: {
		key: 'view',
	},
}

export const NAVIGATION_LAYERS = {
	base: [
		NAVIGATION_ROUTE_TYPES.base.key
	],
	group: [
		NAVIGATION_ROUTE_TYPES.group.key,
		NAVIGATION_ROUTE_TYPES.companySettings.key,
		NAVIGATION_ROUTE_TYPES.companyPersonalSettings.key,
		NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
		NAVIGATION_ROUTE_TYPES.profileSettings.key,
	],
	module: [
		NAVIGATION_ROUTE_TYPES.module.key,
		NAVIGATION_ROUTE_TYPES.companySettingsChild.key,
	],
	page: [
		NAVIGATION_ROUTE_TYPES.view.key
	],
	userPages: [
		NAVIGATION_ROUTE_TYPES.userPages.key
	],
	profileSettings: [
		NAVIGATION_ROUTE_TYPES.profileSettings.key
	]
}

export const COMPANY_GROUPS_NAMES = {
	TEST: 'CompanyGroupTestPage',

	PLANNING__CROP_PRODUCTION: 'CompanyGroupCropProductionPage',
	PLANNING__TRANSPORTATION: 'CompanyGroupTransportationPage',
	PLANNING__MAINTENANCE: 'CompanyGroupMaintenancePage',
	PLANNING__PROJECTS: 'CompanyGroupProjectsPage',

	WORKS__MY_TASKS: 'CompanyGroupMyTasksPage',
	WORKS__CONTROL: 'CompanyGroupControlPage',
	WORKS__FIELD: 'CompanyGroupWorksInFieldPage',
	WORKS__LOGISTICS: 'CompanyGroupLogisticsPage',
	WORKS__REPAIR: 'CompanyGroupRepairWorkPage',
	WORKS__PROJECT_TASKS: 'CompanyGroupProjectTasksPage',

	CAR_PARK__GPS_MONITORING: 'CompanyGroupGpsMonitoringPage',
	CAR_PARK__TECHNIQUE_AND_EQUIPMENT: 'CompanyGroupTechniqueAndEquipmentPage',

	REPORTS__ALL_WORKS: 'CompanyGroupAllWorksPage',
	REPORTS__TECHNIQUE_AND_DEVICES: 'CompanyGroupTechniqueAndDevicesPage',
	REPORTS__INVENTORY_CONTROL: 'CompanyGroupInventoryControlPage',
	REPORTS__ECONOMY: 'CompanyGroupEconomyPage',
	REPORTS__CONDITION_OF_CROPS: 'CompanyGroupConditionOfCropsPage',

	REAL_ESTATE__INFRASTRUCTURE: 'CompanyGroupRealEstatePage',
	REAL_ESTATE__LAND_BANK: 'CompanyGroupLandBankPage',
}

export const COMPANY_REFERENCE_MATERIALS_NAMES = {
	INFRASTRUCTURE__GROUPS: 'CompanyReferenceMaterialsInfrastructureTypesPage',
	INFRASTRUCTURE__TAGS: 'CompanyReferenceMaterialsInfrastructureTagsPage',

	STAFF__LIST: 'CompanyReferenceMaterialsStaffPage',
	STAFF__DEPARTMENTS: 'CompanyReferenceMaterialsStaffDepartmentsPage',
	STAFF__GROUPS: 'CompanyReferenceMaterialsStaffGroupsPage',
	STAFF__ROLES: 'CompanyReferenceMaterialsStaffRolesPage',
	STAFF__WORKS_SHIFTS: 'CompanyReferenceMaterialsWorksShiftsPage',

	RESOURCES__LIST: 'CompanyGroupResourcesModuleResourcesTablePage',
	RESOURCES__MATERIALS_CATEGORIES: 'CompanyReferenceMaterialsMaterialsCategoriesPage',
	RESOURCES__MATERIALS_TAGS: 'CompanyReferenceMaterialsMaterialsTagsPage',
	RESOURCES__CARGO_TAGS: 'CompanyGroupReferenceMaterialsCargoTagsTablePage',

	CAR_PARK__MACHINES_GROUPS: 'CompanyReferenceMaterialsMachinesGroupsPage',
	CAR_PARK__EQUIPMENT_GROUPS: 'CompanyReferenceMaterialsEquipmentGroupsPage',
	CAR_PARK__LOGISTIC_ROUTE_TAGS: 'CompanyReferenceMaterialsLogisticRouteTagsPage',

	COUNTERPARTIES__LIST: 'CompanyReferenceMaterialsCounterpartiesPage',
	COUNTERPARTIES__GROUPS: 'CompanyReferenceMaterialsCounterpartiesGroupsPage',

	INSPECTIONS__TEMPLATES: 'CompanyReferenceMaterialsInspectionsTemplatesPage',
	INSPECTIONS__PROBLEM_CATEGORIES: 'CompanyReferenceMaterialsInspectionsProblemCategoriesPage',
	INSPECTIONS__PROBLEMS: 'CompanyReferenceMaterialsInspectionsProblemsPage',
	INSPECTIONS__MEASURE_CATEGORIES: 'CompanyReferenceMaterialsInspectionsMeasureCategoriesPage',
	INSPECTIONS__MEASURES: 'CompanyReferenceMaterialsInspectionsMeasuresPage',

	NORMS__SERVICE_PAYMENT: 'CompanyReferenceMaterialsWorksServicePaymentRatesNormsPage',
	NORMS__MATERIAL_PRODUCTION: 'CompanyReferenceMaterialsWorksMaterialProductionRateNormsPage',
	NORMS__MATERIAL_CONSUMPTIONS: 'CompanyReferenceMaterialsWorksMaterialConsumptionsRateNormsPage',
	NORMS__STAFF_PAYMENT: 'CompanyReferenceMaterialsWorksStaffPaymentRatesNormsPage',
	NORMS__PRODUCTIVITY: 'CompanyReferenceMaterialsWorksProductivityNormsPage',
	NORMS__QUALITY: 'CompanyReferenceMaterialsWorksQualityNormsPage',

	LAND_BANK__FIELD_TAGS: 'CompanyReferenceMaterialsFieldsTagsPage',
	LAND_BANK__LAND_PURPOSES: 'CompanyGroupReferenceMaterialsLandPurposesTablePage',
	LAND_BANK__LAND_OWNERSHIP_TYPES: 'CompanyGroupReferenceMaterialsLandOwnershipTypesTablePage',
	LAND_BANK__LAND_CATEGORIES: 'CompanyGroupReferenceMaterialsLandCategoriesTablePage',
	LAND_BANK__LAND_ACTIONS: 'CompanyGroupReferenceMaterialsLandActionsTablePage',
	LAND_BANK__LAND_DOCUMENT_TYPES: 'CompanyGroupReferenceMaterialsLandDocumentTypesTablePage',

	FINANCE__CATEGORIES: 'CompanyReferenceMaterialsFinanceCategoriesPage',
	FINANCE__GROUPS: 'CompanyReferenceMaterialsFinanceGroupsPage',
	FINANCE__TAGS: 'CompanyReferenceMaterialsFinanceTagsPage',

	WORKS__LIST: 'CompanyReferenceMaterialsWorksPage',
	WORKS__CATEGORIES: 'CompanyReferenceMaterialsWorksCategoriesPage',
	WORKS__COST_CATEGORIES: 'CompanyReferenceMaterialsWorksCostCategoriesPage',
	WORKS__REPORT_LINK_TYPES: 'CompanyReferenceMaterialsWorkReportLinksPage',
	WORKS__MEASURE_TYPES: 'CompanyReferenceMaterialsWorkReportMeasuresPage',
	WORKS__REPORT_PHOTO_TYPES: 'CompanyReferenceMaterialsWorkReportPhotosPage',
	WORKS__REPORT_DOCUMENT_TYPES: 'CompanyReferenceMaterialsWorkReportDocumentsPage',
	WORKS__REGULATION_TAGS: 'CompanyReferenceMaterialsRegulationTagsPage',
	WORKS__REGULATION_STAGE_TAGS: 'CompanyReferenceMaterialsRegulationsStageTagsPage',
	WORKS__INCIDENT_TAGS: 'CompanyReferenceMaterialsIncidentTagsGroupsPage',
}

export const CATEGORY_GROUP_KEYS = {
	DEVELOP: 'develop',
	PLANNING: 'planning',
	WORKS: 'works',
	CAR_PARK: 'carPark',
	REPORTS: 'reports',
	REAL_ESTATE: 'realEstate',
}

export const REFERENCE_GROUP_KEYS = {
	INFRASTRUCTURE: 'infrastructure',
	STAFF_DEPARTMENTS: 'staffDepartments',
	RESOURCES: 'resources',
	CAR_PARK: 'carPark',
	COUNTERPARTIES: 'counterparties',
	INSPECTIONS: 'inspections',
	NORMS: 'norms',
	LAND_BANK: 'landBank',
	FINANCES: 'finances',
	WORKS: 'works',
}

export const ROUTER_QUERY_KEYS = {
	APP_LOCALE: 'locale',
	MAP_SETTINGS: 'ms',
	MAP_GLOBAL_FILTERS: 'mgf',
	DISPATCHER_GLOBAL_FILTERS: 'dgf',
	TABLE_GLOBAL_FILTERS: 'gf',
	CARD_PERIOD: 'cp',
	REDIRECT_PARAMS: 'rp',
	TABLE_OPENED_PREVIEW: 'openedPreview',
	TABLE_OPENED_EDITING_FORM: 'openedEditingForm',
	DASHBOARD_GLOBAL_FILTERS: 'dbgf',
	DASHBOARD_VIEW: 'dv',
	BACK_PATH_PARAMS: 'bpp',
}

export const ROUTER_VIEW_VARIANTS_OF_ENTITY_LISTS_CONFIG = {
	analytics: {
		translationKey: 'Analytics',
		icon: 'dashboardView',
	},
	dashboard: {
		translationKey: 'Dashboard',
		icon: 'dashboardView',
	},
	terminal: {
		translationKey: 'Terminal',
		icon: 'dashboardView',
	},
	table: {
		translationKey: 'Table',
		icon: 'tableView',
	},
	map: {
		translationKey: 'Map',
		icon: 'map',
	},
	schedule: {
		translationKey: 'Chart',
		icon: 'scheduleView',
	},
	timeline: {
		translationKey: 'Timeline',
		icon: 'timelineView',
	},
	calendar: {
		translationKey: 'Calendar',
		icon: 'calendarView',
	},
	comparison: {
		translationKey: 'Comparison',
		icon: 'comparisonView',
	},
	list: {
		translationKey: 'MenuTabs.List',
		icon: 'listView',
	},
	monitor: {
		translationKey: 'Monitor',
		icon: '',
	},
}

// const ROUTE_NAMES_MAP = {
// 	CompanyGroupTestModuleTestPage: 'CompanyGroupTestModuleTestPage',
// }
